import React from 'react';

import { Badge, HoverCard, Text } from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

interface DeauthorizedBadgeProps {
  label?: string;
  description?: string;
}

export function DeauthorizedBadge({ label, description }: DeauthorizedBadgeProps) {
  const { t } = useTranslation();

  return (
    <HoverCard styles={{ dropdown: { maxWidth: 250 } }}>
      <HoverCard.Target>
        <Badge
          color="red"
          variant="outline"
          size="sm"
          ml="md"
          tt="none"
          style={{ cursor: 'pointer' }}
          leftSection={<IconAlertCircle style={{ width: 13, height: 13, marginTop: 4 }} />}>
          {label || t('APP.DEAUTHORIZED.LABEL')}
        </Badge>
      </HoverCard.Target>
      <HoverCard.Dropdown>
        <Text>{description || t('APP.DEAUTHORIZED.DESCRIPTION')}</Text>
      </HoverCard.Dropdown>
    </HoverCard>
  );
}
